const lang = {
  common: {
    page_name_first: 'サエダオリジナル年賀状サービ',
    page_name_last: 'ス',
    copyright: 'Copyright &copy; SAEDA. All rights reserved',
    default_title: 'サエダオリジナル年賀状サービス',
    error_page: {
      text_1: 'エラーが発生しました。',
      text_2:
        'ご不便をおかけしまして申し訳ございません。<br>ただいまエラーの解決に取り組んでおります。',
      text_3:
        'しばらくたっても改善されない場合は、 <br>お手数ですが最寄りの店舗までお問い合せください。',
      text_4: 'トップ画面へ戻る',
      error400: '不正な要求です。(400)',
      error401: '認証に失敗しました。(401)',
      error403: 'セッションの有効期限切れです。(403)',
      error404: '対象ファイルが存在しません。(404)',
      error409: 'DB更新に失敗しました。(409)',
      error422: '要求内容が不正です。(422)',
      error500: '内部エラーが発生しました。(500)',
      error502: '不正な要求です。(502)',
      error503: 'システム使用不可。(503)',
      error_network: 'ネットワークエラー(Network Error)',
    },
  },
  shop_mode: {
    messages: {
      store_not_exist: '店舗IDが存在しません',
    },
    label: '店舗モード：',
    alert_release: {
      content: [
        '年賀状はサエダにお任せください！球団/クラブ承認のカープ年賀状・サンフレッチェ年賀状などバリエーション豊富なデザインを取り揃えています！',
      ],

      btn: {
        release: '解除する',
        cancel: 'キャンセル',
      },
    },

    alert_enter: {
      content: [
        '店舗モードに切り替えますか？',
        'ご利用の店舗 ID を入力してください。',
      ],
      shop_id_label: '店舗ID_値',
      btn: {
        enter: '続ける',
        cancel: 'キャンセル',
      },
    },
  },
  a005: {
    btn: {
      create_postcard: 'ポストカードを作成する',
      reorder: {
        text1: '再注文（追加注文）する方はこちらから',
        text2: '注文イメージ確認する方はこちらから',
      },
      image_confirm: '注文イメージ確認',
      confirm_image_order: '注文イメージ確認',
    },
  },
  a008: {
    title: 'カテゴリ選択',
    btn: {
      all_year: '通年',
      holiday: '年賀',
    },
    mapUrl: {
      年賀: 'newyear',
      通年: 'normal',
    },
  },
  a010: {
    btn: {
      use_template: 'このテンプレートを使用する',
    },
    title: 'テンプレート一覧',
    private_type: '非公開',
  },
  a025: {
    btn_edit: '編集する',
    btn_submit: '注文する',
    order_number: 'オーダー番号',
    message_confirm: 'メッセージや写真が切れていないかご確認ください。',
    title: 'デザイン詳細確認',
    order_number_label: 'オーダー番号 : ',
    public_template: '公開',
  },
  a030: {
    title: '利用規約',
    term:
      '以下の内容をご確認の上「同意する」ボタンを<br class="break-line">押して注文を続行してください。',
    button_check_next: '同意する',
    content: {
      policy_one: '第1条（通則）',
      policy_one_one:
        '株式会社SAEDA（以下、「SAEDA」という）が運営するSAEDAのウェブサイト（以下、「本サイト」という）において提供するサービス（以下、「本サービス」という）の利用について、以下のとおり、サエダオリジナル年賀状サービス利用規約本則（以下、「本則」という）を定めます。',
      policy_one_one_br_a:
        'また、本サービスのご利用において、本則とは別に、個別の規約（SAEDAが本則を補完するために設けるガイドライン、ルールを総称して「個別規約」という）が存在する場合、個別規約は、本則と一体となって一つの規約（以下、「本規約」という）を構成します。',
      policy_one_one_br_b:
        'お客様が、本サービスをご利用になるには、本規約を承認していただく必要があります。',
      policy_one_one_br_c:
        'なお、本則と個別規約が抵触する場合は、個別規約が優先して適用され、その他の部分については、本則と個別規約が同時に適用されるものとします。',
      policy_two: '第2条（定義）',
      policy_two_one_one_list: '（1）',
      policy_two_one:
        '本則において、次の用語は、次の各号に定める意味で用いるものとします。',
      policy_two_one_two_list: '（2）',
      policy_two_one_one:
        '「利用者」とは、本則を承認のうえ、本サービスを利用する（本サイトの閲覧も含みます）個人または法人・機関・団体（以下、「法人」という）を指します',
      policy_two_one_three_list: '（3）',
      policy_two_one_two:
        '「商品」とは、制作物などの物品、権利、デジタルコンテンツおよびサービスを総称していいます',
      policy_two_one_four_list: '（4）',
      policy_two_one_three:
        '「コンテンツ」とは、本サービスに含まれるデザインテンプレート、イラスト、写真素材、本サイトの文章、画像、動画、プログラム、商標、広告等を指します',
      policy_two_one_four:
        '「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、またはそれらの登録等を出願する権利を含む。）を指します',
      policy_three: '第3条（本規約の適用および変更）',
      policy_thre_one:
        '本規約は、SAEDAと利用者の間の一切の関係に適用されるものとします。',
      policy_three_two:
        'SAEDAは、利用者に個別の了解を得ることなく本規約を変更できるものとし、当該変更内容を本サイトに掲載することにより、直ちに発効するものとします。',
      policy_four: '第4条（本サービスの利用資格および条件）',
      policy_four_one:
        '利用者は、本規約に同意し、自己の責任において本サービスを利用するものとします。',
      policy_four_two:
        '利用者は、過去、現在または将来にわたって、暴力団等の反社会的勢力に所属せず、これらのものと関係を有しないものとします。',
      policy_four_three:
        '利用者は、SAEDAが本サイトのコンテンツの表示制御にCookie（クッキー）およびJavaScript（ジャバスクリプト）を使用することに了承し、SAEDAが別に定める利用推奨環境において本サービスを利用するものとします。',
      policy_four_three_br:
        'ただし、サービス個別に独自の機能を提供するため、利用推奨環境が異なる場合は、当該サービスにおいて利用推奨環境を表示するものとします。',
      policy_four_four:
        'SAEDAは、本サービスの利用において、商品の注文を会員に限定するなど、利用に際して条件を付すことができるものとします。',
      policy_five: '第5条（本サービスの変更および一時停止、廃止）',
      policy_five_one:
        'SAEDAは、利用者に事前の予告なく、本サービスの内容やデザインを変更できるものとします。',
      policy_five_two:
        'SAEDAは、下記の各号のいずれかに該当する場合は、利用者に事前の予告なく、本サービスの一部または全体を一時停止または廃止できるものとします。',
      policy_five_two_one_list: '（1）',
      policy_five_two_one:
        '本サービスを提供するために必要なシステム環境の定期的または緊急的なメンテナンスを実施する場合',
      policy_five_two_two_list: '（2）',
      policy_five_two_two:
        'SAEDAの責に帰すべき事由か否かに関わらず、システム環境または通信回線等に支障が発生した場合',
      policy_five_two_three_list: '（3）',
      policy_five_two_three:
        '利用者からのアクセスやサービス利用が集中するなど、SAEDAの対応範囲を超える場合',
      policy_five_two_four_list: '（4）',
      policy_five_two_four: '火災、停電が発生した場合',
      policy_five_two_five_list: '（5）',
      policy_five_two_five: '地震、洪水、津波、噴火等の天災地変が発生した場合',
      policy_five_two_six_list: '（6）',
      policy_five_two_six: '戦争、暴動等が発生した場合',
      policy_five_two_seven_list: '（7）',
      policy_five_two_seven:
        '個人情報の漏洩などのセキュリティ事故が発生した場合',
      policy_five_two_eight_list: '（8）',
      policy_five_two_eight:
        'その他、SAEDAが本サービスの運営が困難と判断した場合',
      policy_six: '第6条（個人情報の取り扱い）',
      policy_six_one: '個人情報の利用目的',
      policy_six_one_br:
        'SAEDAは、本サービスにおいて取得する個人情報について、あらかじめ本人のご同意を得た場合およびその他法令により例外として取り扱うことが認められている場合を除き、大きく分けて下記の各号の目的範囲内で利用いたします。',
      policy_six_one_one_list: '（1）',
      policy_six_one_one:
        'ご注文等の各種お申し込みの受付、商品個別契約の成立等の通知を行う為',
      policy_six_one_two_list: '（2）',
      policy_six_one_two:
        '利用者からのお問い合わせに対して、回答に必要となるサービスのご利用状況などを確認する為',
      policy_six_one_three_list: '（3）',
      policy_six_one_three:
        '前項において、お問い合わせへの返信・電話を行う際に、連絡先を参照する為',
      policy_six_one_four_list: '（4）',
      policy_six_one_four: '資料のご請求に対して、納品先を参照するため',
      policy_six_one_five_list: '（5）',
      policy_six_one_five: 'お見積りのご依頼に対し、見積り結果を返信するため',
      policy_six_one_six_list: '（6）',
      policy_six_one_six:
        '利用者が簡便にデータを入力できるようにするなどユーザービリティを向上させる為',
      policy_six_one_seven_list: '（7）',
      policy_six_one_seven:
        '商品個別契約に基づいて、ご注文の商品を製作・印刷（名刺・宛名印刷も含む）・加工する為',
      policy_six_one_eight_list: '（8）',
      policy_six_one_eight:
        '商品個別契約に基づいて、本サービスの利用代金を請求する際に、請求先を参照する為',
      policy_six_one_nine_list: '（9）',
      policy_six_one_nine:
        '商品個別契約に基づいて、完成した商品を納品する際に、納品先を参照する為',
      policy_six_one_ten_list: '（10）',
      policy_six_one_ten:
        '前3号の作業において、確認・質問事項が発生し、SAEDAから利用者へ連絡する為',
      policy_six_one_eleven_list: '（11）',
      policy_six_one_eleven:
        '問い合わせ対応スタッフの対応状態を点検したり、利用者との通話内容を確認したりする為',
      policy_six_one_twelve_list: '（12）',
      policy_six_one_twelve:
        '新サービス、新商品、機能改善等お客様に有用と思われる情報の告知を行う為',
      policy_six_one_thirteen_list: '（13）',
      policy_six_one_thirteen:
        '本サービスの障害情報、メンテナンス情報等、技術的なサポートに関する通知を行う為',
      policy_six_one_fourteen_list: '（14）',
      policy_six_one_fourteen:
        'ご登録情報を元に、個人として特定できない範囲において統計情報として集計し、利用者に有用なサービス開発や機能改善を行う参考資料とする為',
      policy_six_one_fifteen_list: '（15）',
      policy_six_one_fifteen:
        'サービス改善のためのアンケート調査やその謝礼の送付の為',
      policy_six_one_sixteen_list: '（16）',
      policy_six_one_sixteen:
        '個人情報を第三者に提供することを、利用者本人からあらかじめ明示的に同意を得ている場合に限り、個人情報を第三者に提供する為',
      policy_six_one_seventeen_list: '（17）',
      policy_six_one_seventeen:
        'その他、本サービスのご利用に際して、個別にご同意を得た利用目的を遂行する為',
      policy_six_two: '個人情報の第三者への提供、開示について',
      policy_six_two_br:
        'SAEDAは、本サービスにおいて取得する個人情報について、下記の各号のいずれかに該当する場合を除き、いかなる第三者にも提供または開示をいたしません。',
      policy_six_two_one_list: '（1）',
      policy_six_two_one: 'ご本人の同意ある、若しくは同意を頂いた場合',
      policy_six_two_two_list: '（2）',
      policy_six_two_two:
        '人の生命、身体および財産の保護の為に必要な場合であってご本人の同意を得ることが困難な場合',
      policy_six_two_three_list: '（3）',
      policy_six_two_three: 'その他法令にもとづき提供、開示を求められた時',
      policy_six_two_four_list: '（4）',
      policy_six_two_four:
        '利用目的の範囲内で業務の一部、または全部を委託する場合',
      policy_six_three: '個人情報の委託',
      policy_six_three_br:
        'SAEDAは、SAEDAが提供するサービスを円滑に進めるため、利用目的の達成に必要な範囲内において業務委託先に対して個人情報の一部または全部を委託する事があります。この場合、個人情報を適切に取り扱っていると認められる委託先を選定し、個人情報の適正管理・機密保持契約書などにより利用者の個人情報の漏洩防止に必要な事項を取決め、適切な管理をいたします。',
      policy_six_four: '個人情報を提供される事の任意性について',
      policy_six_four_br_a:
        'SAEDAに個人情報を提供されるかどうかは、本人の任意によるものです。',
      policy_six_four_br_b:
        'ただし、必要な項目をご提供いただけない場合、各種サービス等が適切な状態でご提供できない場合があります。',
      policy_six_five: 'その他の注意事項',
      policy_six_five_br_a:
        '本サイトでは、Cookie（クッキー）を使用する場合がありますが、本サイトでは、Cookie等を用いて本人が容易に認識できない方法による個人情報の取得は行っておりません。Cookieは、利用者が本サイトをより便利に利用していただくためのものであり、利用者のプライバシーを侵害するものではなく、また利用者のコンピューターに悪影響を及ぼすことはありません。',
      policy_six_five_br_b:
        'また、本サイトではファイアウォール、SSL暗号化通信などの安全対策を講じておりますが、インターネット通信の性格上、セキュリティを完全に保証するものではありません。あらかじめご了承ください。',
      policy_six_six: '個人情報に関するお問い合わせ先',
      policy_six_six_br_a: '株式会社SAEDA',
      policy_six_six_br_b: '所在地　〒732-0048 広島市東区山根町28-16',
      policy_six_six_br_c:
        'TEL　082-263-7699（受付時間 平日10:00～17:00、土・日・祝日・年末年始を除く）',
      policy_six_six_br_d: 'FAX　082-263-0416',
      policy_seven: '第7条（知的財産権）',
      policy_seven_one:
        '本サービスに含まれるコンテンツに関する知的財産権は、SAEDAまたは当該コンテンツを制作および提供した著作者もしくは著作権者に帰属します。',
      policy_seven_two:
        '利用者は、コンテンツの知的財産権を有するSAEDAまたは第三者から明示的に承諾を受けた場合を除き、本サービスの利用以外のいかなる目的であってもコンテンツ（一部または全部に関わらず）を利用し、または第三者の利用に供することはできないものとします。',
      policy_eight: '第8条（禁止事項）',
      policy_eight_one:
        'SAEDAは、利用者の行為が、下記の各号のいずれかに該当する場合は、本サービスの一時停止または利用契約の解除をすることができます。',
      policy_eight_one_one_list: '（1）',
      policy_eight_one_one: '本規約に違反する全ての行為',
      policy_eight_one_two_list: '（2）',
      policy_eight_one_two:
        '法令または公序良俗に反する行為、または恐れのある行為',
      policy_eight_one_three_list: '（3）',
      policy_eight_one_three:
        '暴力的要求行為または反社会的行為、または恐れのある行為',
      policy_eight_one_four_list: '（4）',
      policy_eight_one_four:
        'SAEDAおよび第三者の知的財産権などの権利を侵害するなど行為、または恐れのある行為',
      policy_eight_one_five_list: '（5）',
      policy_eight_one_five:
        'SAEDAおよび第三者の名誉や信用を毀損する行為、または恐れのある行為',
      policy_eight_one_six_list: '（6）',
      policy_eight_one_six:
        'SAEDAのサーバーまたはネットワークに著しく負荷をかける行為',
      policy_eight_one_seven_list: '（7）',
      policy_eight_one_seven: 'コンピューターウィルス等を使用する行為',
      policy_eight_one_eight_list: '（8）',
      policy_eight_one_eight:
        '本サービスの運営を妨害する行為、または恐れのある行為',
      policy_eight_one_nine_list: '（9）',
      policy_eight_one_nine:
        '上記各項に定める禁止行為に関与する行為、助長する行為',
      policy_eight_one_ten_list: '（10）',
      policy_eight_one_ten: 'その他、SAEDAが不適当と判断する行為',
      policy_nine: '第9条（利用者の責任）',
      policy_nine_one:
        '利用者は、本サービスの利用に関連して、SAEDAに損害を与えた場合、SAEDAに対して、その一切の損害を補償するものとします。',
      policy_nine_two:
        '利用者は、本サービスの利用に関連して、第三者からのクレームを受けた場合および当該第三者との紛争に発展した場合、自己の費用と責任において、これを解決するものとします。',
      policy_ten: '第10条（非保証・免責）',
      policy_ten_one:
        'SAEDAは、本サービス内容等の変更または一時停止や廃止を実施したことによって、利用者に損害が生じた場合でも、一切の責任は負わないものとします。',
      policy_ten_two:
        'SAEDAは、コンテンツの正確性、適法性については、一切保証しないものとし、利用することによって発生した損害に対して、一切の責任を負わないものとします。',
      policy_ten_three:
        '利用者は、本サービスの利用にあたり、自らデータをバックアップするものとし、SAEDAは、利用者が、自らバックアップしなかったことにより被った損害・損失に対して、一切の責任を負わないものとします。',
      policy_ten_four:
        'SAEDAは、利用者が第三者の名誉や信用を毀損したり、知的財産権などの権利を侵害したりして発生した紛争・損害等に対して、一切の責任を負わないものとします。',
      policy_ten_five:
        '本サービスに関連して利用者が被った損害・損失に対して、SAEDAは故意または重過失による場合を除き、一切の責任を負わないものとします。',
      policy_eleven: '第11条（専属的合意管轄裁判所）',
      policy_eleven_br:
        'SAEDAと利用者との間で訴訟の必要が生じた場合、広島地方裁判所を第一審の専属的合意管轄裁判所とします。',
      policy_twelve: '第12条（準拠法）',
      policy_twelve_br:
        '本規約の成立、効力発生、解釈にあたっては日本法を準拠法とします。',
    },
  },
  a035: {
    title: 'ご注文者様の情報入力',
    name: 'ご注文者様の情報入力',
    label: {
      order_number: 'オーダー番号',
      name: 'お名前',
      name_furigana: 'フリガナ',
      email: 'メール',
      phone_number: '電話番号',
      ship_address: {
        ship_address: '発送先住所',
        postal_code: '郵便番号',
        prefectures: '都道府県',
        city: '市区町村',
        address_number: '丁・番地・号',
        building_name: '建物名',
      },
      company_name: '会社名',
      department_name: '部署名',
      comment: 'コメント欄',
    },
    alert: {
      button: {
        cancel: 'キャンセル',
        temporarily_save: '一時保存する',
        print_address: '宛名面の印刷をする',
        no_print_address: '宛名面を印刷しない',
        bring_in: '持ち込みあり',
        no_bring_in: '持ち込みなし',
        continue: '続ける',
        back_to_top: 'トップへ戻る',
      },
      text: {
        temporarily_save:
          '一時保存したデータは、１日間情報が保持されます。</br>有効期限を過ぎるとデータは破棄されます。</br>一時保存して注文を中断しますか？',
        send_mail_success:
          '<p>一時保存完了のメールをご入力頂いたメールアドレスに送信しました。</br>作成したハガキのデータとご注文者様の情報が１日間保持されます。</p>' +
          '<p>注文を続行する場合や、作成したハガキを編集するには送信された</br>メールアドレス本文に記載されたURLにアクセスしてください。</p>' +
          '<p>一時保存した画面から注文を再開できます。</p>',
        continue_order: "<p class='text-center'>宛名面の印刷をしますか？</p>",
        continue_order_mode_store:
          '持ち込みハガキで注文する場合は「持ち込みあり」を<br>選択してください。',
      },
    },
    button: {
      temporarily_save: '一時保存する',
      continue_order: '注文を続ける',
      automatic_input_code: '自動入力',
    },
    placeholder: {
      first_name: '姓',
      last_name: '名',
      first_name_furigana: 'セイ',
      last_name_furigana: 'メイ',
    },
    validate: {
      required: 'を入力してください',
      length: 'の長さに誤りがあります',
      number_format: 'は半角数字で入力してください',
      name_format: 'お名前は全角で入力してください',
      name_furigana_required: 'フリガナを入力してください',
      name_furigana_format: 'は全角カナで入力してください',
      email_required: 'メールを入力してください',
      email_format: 'メールアドレスを正しく入力してください',
      phone_number_required: '電話番号を入力してください',
      phone_number_limit: '電話番号を正しく入力してください',
      phone_number_format: '電話番号は半角数字で入力してください',
      zip_code_required: '郵便番号を入力してください',
      zip_code_limit: '郵便番号は7桁で入力してください',
      zip_code_format: '郵便番号は半角数字で入力してください',
      zip_code_exist: '郵便番号を正しく入力してください',
      prefecture_required: '都道府県を選択してください',
      city_required: '市区町村を入力してください',
      city_format: '市区町村は全角で入力してください',
      street_required: '丁・番地・号を入力してください',
      mail_not_send: '送信できないメールアドレスです',
    },
    errors: {
      postal_code: {
        length: '郵便番号の長さに誤りがあります',
        half_size_number: '郵便番号は半角数字で入力してください',
        required: '郵便番号を入力してください',
      },
    },
    message_confirm_before_unload:
      'データが保持されない場合があります。 続行しますか？',
  },
  a050: {
    title: '宛名登録',
    btn_back: '宛名面の印字選択',
    download_template: '宛名印刷用のCSVファイルをダウンロード',
    upload_file: '宛名印刷用のCSVファイルをアップロード',
    enter_address: '個別に入力する',
    list_receiver: '宛先ー覧',
    choose_all: '一括選択する',
    confirm: '決定',
    read_file: 'アップロードする',
    name_file: '選択ファイル：',
    no: 'No',
    name: '氏名',
    address: '住所',
    joint_name: '連名',
    csv: {
      message_confirm_read_file: 'アップロードしてもよろしいですか？',
      yes: 'はい',
      cancel: 'いいえ',
      error_no_file: 'ファイルを選択してください',
      error_not_csv: '選択したファイルに誤りがあります',
      error_not_format: 'ファイルフォーマットに誤りがあります',
      insert_complete: '登録が完了しました',
      register_confirm: '宛名情報を決定してもよろしいですか？',
      back_register: '宛名登録一覧画面に戻る',
      message_confirm_download:
        '宛名印刷用のCSVファイルをダウンロードしてもよろしいですか？',
      message_confirm_receivers: '注文情報を更新してもよろしいですか？',
      back_info_order: '注文情報入力画面に戻る',
      file_size_limit: '容量が4MB以下の.CSVファイルを選択してください。',
      confirm_delete: '入力された宛名情報は破棄されますがよろしいですか？',
      ok: 'OK',
      error_encoding:
        'アップロードするファイルの文字コードは「UTF-8」または「S-JIS」で保存してください',
    },
    header_csv: [
      '郵便番号',
      '住所1(番地まで）',
      '住所1（マンション名・号）',
      '会社名',
      '部署名1',
      '役職',
      '姓',
      '名',
      '敬称',
      '家族1',
      '家族１（敬称）',
    ],
  },
  a055: {
    name: '名前',
    back_note_ipad:
      '入力を終了して宛名登録画面に戻りたい場合は画面左上の矢印<br>アイコンをクリック・タップしてください',
    back_note_sp:
      '入力を終了して宛名登録画面に戻りた <br> い場合は画面左上の矢印アイコンをク <br> リック・タップしてください',
    title: '宛名個別登録',
    auto_input: '自動入力',
    zip_code: '郵便番号',
    address: '住所（都道府県）',
    address_district: '住所（市区町村）',
    street: '住所（番地）',
    building: '住所（建物）',
    next_name: '連名',
    confirm: '決定',
    city_name: '会社名',
    deploy_name: '部署名',
    position: '役職',
    first_name: '姓',
    last_name: '名',
    honorific_title: '敬称',
    text_add_plus: '連名を追加する',
    message_confirm: '登録が完了しました <br> 続けて登録しますか？',
    message_confirm_success: '登録が完了しました続けて登録しますか？',
    register_address_confirm: '宛名を登録してもよろしいですか？',
    yes: 'はい',
    cancel: 'いいえ',
    name_link_plus: '連名',
    insert_receiver_complete: '登録が完了しました',
    continue: '続けて登録しますか？',
    validate: {
      required: 'を選択してください。',
      required_jointname: 'を入力してください',
      zip_code_required: '郵便番号を入力してください',
      zip_code_limit: '郵便番号は7桁で入力してください',
      zip_code_format: '郵便番号は半角数字で入力してください',
      zip_code_exist: '郵便番号を正しく入力してください',
      prefecture_required: '都道府県を選択してください。',
      city_required: '市区町村を入力してください',
      city_format: '市区町村は使用できない文字があります',
      street_required: '番地を入力してください',
      name_link_first: '連名',
      name_link_last: '名は使用できない文字があります',
      company_required: '会社名は使用できない文字があります',
      department_required: '部署名は使用できない文字があります',
      position_required: '役職は使用できない文字があります',
      sub_name_first_required: '_名を入力してください',
      sub_name_last_required: '_敬称を入力してください',
      sub_name_first_format: '_名は使用できない文字があります',
      sub_name_last_format: '_敬称は使用できない文字があります',
      first_name_required: '名前_姓を入力してください',
      last_name_required: '名前_名を入力してください',
      honorific_name_required: '名前_敬称を入力してください',
      first_name_format: '名前_姓は使用できない文字があります',
      last_name_format: '名前_名は使用できない文字があります',
      honorific_name_format: '名前_敬称は使用できない文字があります',
      name_error_format: '名前を正しく入力してください',
      name_error_empty: '名前を入力してください',
      address_district_full_size: '住所（市区町村)  は全角で入力してください',
    },
    errors: {
      invalid_phone: '電話番号を正しく入力してください',
      invalid_postal_code: '郵便番号の長さに誤りがあります。',
    },
  },
  a070: {
    title: 'ご注文者様の情報変更',
    name: 'ご注文者様の情報変更',
    label: {
      order_number: 'オーダー番号',
      name: 'お名前',
      name_furigana: 'フリガナ',
      email: 'メール',
      phone_number: '電話番号',
      ship_address: {
        ship_address: '発送先住所',
        postal_code: '郵便番号',
        prefectures: '都道府県',
        city: '市区町村',
        address_number: '丁・番地・号',
        building_name: '建物名',
      },
      company_name: '会社名',
      department_name: '部署名',
      comment: 'コメント欄',
    },
    button: {
      temporarily_save: '一時保存する',
      continue_order: '注文を続ける',
      automatic_input_code: '自動入力',
      change: '変更する',
    },
    placeholder: {
      first_name: '姓',
      last_name: '名',
      first_name_furigana: 'セイ',
      last_name_furigana: 'メイ',
    },
    validate: {
      name_required: 'お名前を入力してください',
      name_format: 'お名前は全角で入力してください',
      name_furigana_required: 'フリガナを入力してください',
      name_furigana_format: 'フリガナは全角カナで入力してください',
      email_required: 'メールを入力してください',
      email_format: 'メールアドレスを正しく入力してください',
      phone_number_required: '電話番号を入力してください',
      phone_number_limit: '電話番号を正しく入力してください',
      phone_number_format: '電話番号は半角数字で入力してください',
      length_phone: '電話番号の長さに誤りがあります',
      zip_code_required: '郵便番号を入力してください',
      zip_code_limit: '郵便番号は7桁で入力してください',
      zip_code_format: '郵便番号は半角数字で入力してください',
      zip_code_exist: '郵便番号を正しく入力してください',
      prefecture_required: '都道府県を選択してください',
      city_required: '市区町村を入力してください',
      city_format: '市区町村は全角で入力してください',
      street_required: '丁・番地・号を入力してください',
      mail_not_send: '送信できないメールアドレスです',
      length_postal_code: '郵便番号の長さに誤りがあります',
    },
    message_confirm_before_unload:
      'データが保持されない場合があります。 続行しますか？',
    message_complete: '更新が完了しました',
    message_back_order: 'ご注文内容確認画面に戻る',
    confirm_message: '注文者情報を更新してもよろしいですか？',
    yes: 'はい',
    cancel: 'いいえ',
    alert: {
      alert_success: '更新が完了しました',
      alert_success_link: 'ご注文内容確認に戻る',
      alert_success_link_select_payment: 'ご注文内容の変更・選択に戻る',
    },
  },
  a075: {
    name: '名前',
    back_note:
      '入力を終了して宛名登録画面に戻りたい場合は画面左上の矢印アイコンをクリック・タップしてください',
    title: '宛名個別登録',
    auto_input: '自動入力',
    zip_code: '郵便番号',
    address: '住所（都道府県）',
    address_district: '住所（市区町村）',
    street: '住所（番地）',
    building: '住所（建物）',
    next_name: '連名',
    confirm: '決定',
    city_name: '会社名',
    deploy_name: '部署名',
    position: '役職',
    first_name: '姓',
    last_name: '名',
    honorific_title: '敬 称',
    text_add_plus: '連名を追加する',
    message_confirm: '宛名を登録してもよろしいですか？',
    yes: 'はい',
    cancel: 'いいえ',
    name_link_plus: '連名',
    insert_receiver_complete: '登録が完了しました',
    continue: '続けて登録しますか？',
    validate: {
      zip_code_required: '郵便番号を入力してください',
      zip_code_limit: '郵便番号は7桁で入力してください',
      zip_code_format: '郵便番号は半角数字で入力してください',
      zip_code_exist: '郵便番号を正しく入力してください',
      prefecture_required: '都道府県を選択してください',
      city_required: '市区町村を入力してください',
      city_format: '市区町村は使用できない文字があります',
      street_required: '番地を入力してください',
      name_link_first: '連名',
      name_link_last: '名は使用できない文字があります',
      company_required: '会社名は使用できない文字があります',
      department_required: '部署名は使用できない文字があります',
      position_required: '役職は使用できない文字があります',
      sub_name_first_required: '_名を入力してください',
      sub_name_last_required: '_敬称を入力してください',
      sub_name_first_format: '_名は使用できない文字があります',
      sub_name_last_format: '_敬称は使用できない文字があります',
      first_name_required: '名前_姓を入力してください',
      last_name_required: '名前_名を入力してください',
      honorific_name_required: '名前_敬称を入力してください',
      first_name_format: '名前_姓は使用できない文字があります',
      last_name_format: '名前_名は使用できない文字があります',
      honorific_name_format: '名前_敬称は使用できない文字があります',
      name_error_format: '名前を正しく入力してください',
      name_error_empty: '名前を入力してください',
    },
  },
  a080: {
    order_number: 'オーダー番号',
    title: '注文完了',
    order_slip: 'OrderSlip-',
    message_first:
      'ご注文ありがとうございました。\r\nご登録頂いたメールアドレスに注文完了のメールを送信いたしました。',
    message_middle:
      '同じ内容で再注文する場合は送信完了のメール本文内に記載の再注文用 URL にアクセスしてください。',
    message_bottom:
      'またはサービストップ画面の「再注文はこちらから」をご利用ください。\r\n（注文番号、ご登録頂いた注文者様のお名前、メール、電話番号が必要です）',
    button_go_back_top: 'サービストップに戻る',
    title_shop: '注文完了_店舗',
    message_first_shop:
      'ご注文ありがとうございました。\r\nご登録頂いたメールアドレスに注文完了のメールを送信いたしました。',
    message_middle_shop:
      '下記の「注文帳票出力」ボタンを押して店舗スタッフへお申し付けの上\r\n店頭にてお支払いをお願いいたします。',
    message_bottom_shop:
      '同じ内容で再注文する場合は送信完了のメール本文内に記載の再注文用 URL にアクセスするか\r\nご利用頂いた店舗スタッフにお問い合わせください。',
    button_view_detail_order_shop: '注文帳票出力',
    message_first_unusual:
      'ご注文ありがとうございます。決済画面での異常によりご注文が完了しておりません。',
    message_middle_unusual_a:
      '大変お手数ですが、同じ内容で再度決済する場合は下記の「ご注文内容の確認へ戻る」画面から「決済へ進む」ボタンを押下しご注文を完了するようお願いいたします。',
    message_middle_unusual_b:
      '（※決済が正常に完了するまで料金のお支払いは発生いたしません）',
    message_bottom_unusual:
      'サービストップ画面に戻る場合、お客様が入力した情報、作成したハガキの内容はすべて破棄されます。\r\nその場合、恐れ入りますが「ポストカードを作成する」ボタンから新規でご注文頂きますようお願いいたします。',
    button_back_confirm: 'ご注文内容の確認に戻る',
    button_clear_data: 'サービストップに戻る',
    message_dialog_confirm_view_order: '注文帳票を出力してもよろしいですか？',
    message_dialog_confirm_destroy_order:
      '作成されたハガキの内容がすべて破棄されますがよろしいですか？',
  },
  a060: {
    confirm_content: '印刷内容の確認',
    font_select: '宛名のフォント選択',
    confirm: '印刷内容を確定',
    re_edit: 'デザイン再編集',
    title: '印刷内容の確認',
    enter_number_print: '印刷枚数を入力してください',
    enter_number_print_bring: '持ち込みハガキ枚数を入力してください',
    number_print: '印刷数',
    number_print_bring: '持ち込み数',
    unit: '枚',
    front: '表',
    behind: '裏',
    number_of_registered_address: '宛名あり（ご登録済みの宛名件数）',
    number_of_copies: '宛名なし',
    sheet: '枚',
    total: '合計',
    postcard_select: 'ハガキの選択',
    message_enter_print_sheet: '【印刷内訳】',
    confirm_edit: 'デザインを再編集しますか？',
    yes: 'はい',
    cancel: 'いいえ',
    combobox_placeholder: 'ーハガキの種類を選択してくださいー',
    coupon_code: 'クーポンコード',
    validate: {
      number_print_format: '半角数字を入力してください',
      number_print_limit: '印刷枚数の上限を超えています。',
      number_postcard_bring_limit:
        '持ち込みハガキ枚数は、印刷枚数以下で入力してください。',
      postcard_select_required: 'ハガキを選択してください',
      number_print_zero: '印刷枚数を入力してください',
      number_new_order_required: '※初回注文は10枚単位です',
      number_print_odd: '初回のご注文は10枚単位で承っております',
      number_print_less_address:
        '合計枚数は宛名登録済みの件数より大きい値で入力してください。',
      postcard_bring_required: '持ち込みハガキ枚数を入力してください。',
      postcard_bring_limit_default:
        '持ち込みハガキ枚数は、印刷枚数以下で入力してください。',
      postcard_bring_limit_total:
        '持ち込みハガキ枚数は、印刷枚数以下で入力してください。',
      min_input_print: '印刷枚数は10枚単位で入力してください。',
      maximun_print_number: '印刷枚数の上限を超えています。',
      coupon_code_not_exists: '入力されたクーポンコードは存在しません',
      invalid_coupon_code: 'クーポンコードは半角数字で入力してください',
      sheet_half_size: '印刷数は半角数字で入力してください。',
      bring_number_half_size: '持ち込みハガキ枚数は半角数字で入力してください',
      number_postcard_except:
        '印刷枚数は1枚以上、1000枚以下で入力してください。',
    },
  },
  a065: {
    front: '表',
    behind: '裏',
    title: 'ご注文内容の確認',
    confirm: '決済に進む',
    confirm_shop: '注文する',
    content_order: '【ご注文内容】',
    item_number: '商品番号',
    fee: '料金',
    yen: '円',
    number_of_sheet: '印刷枚数',
    address_print: '宛名印字',
    orderer: 'ご注文者様',
    edit_orderer: '修正する',
    name: '名前',
    phone_number: '電話番号',
    shipping_address: '発送先住所',
    department_name: '部署名',
    company_name: '会社名 ',
    mail_address: 'メールアドレス',
    comment: 'コメント欄',
    pay_method: 'お支払い',
    credit_card: 'クレジットカード',
    store_payment: 'コンビニ払い',
    counter_payment: '店頭支払い',
    message_confirm:
      '内容に問題がなければ［決済に進む］ボタンを押してください。',
    message_payment:
      '「クロネコ WEB コレクト」の画面へ遷移します。遷移後の画面にてお支払い方法を選択してください。',
    message_complete:
      '決済完了後にご注文が確定します。本画面でご注文はまだ確定しておりません。',
    message_payment_shop:
      'お支払いは店内のレジにて承ります。次の画面で注文帳票を出力します。',
    message_confirm_shop:
      '内容に問題がなければ下記のボタンを押して注文を確定してください',
    message_check_print_invoice:
      '領収書をご希望のお客様はチェックを入れてください。',
    message_note3:
      '代引きでの決済をご希望の場合は、[代引き決済に進む]ボタンを押してください。',
    message_note4:
      '「ご注文内容の確認（代引き）」の画面へ遷移します。遷移後の画面にてご注文の内容をご確認ください。',
    confirm_edit_user_info: 'ご注文者様情報を修正しますか？',
    yes: 'はい',
    cancel: 'いいえ',
    message_confirm_payment: '決済画面に遷移してもよろしいですか？',
    message_confirm_payment_shop: '注文を確定してもよろしいですか？',
    invoice_detail: {
      fee_basic_image: '基本料金',
      fee_basic_print: '印刷料金',
      type_order: '注文タイプ番号',
      detail_invoice: '料金明細',
      date_order: 'ご注文受付日',
      id_order: ' オーダー番号',
      money_option: 'オプション料金',
      fee_print: 'プリント料金',
      number_of_print: 'プリント数',
      fee_total: '計',
      discount: '割引',
      discount_total: '割引_適用計',
      fee_postcard: 'ハガキ代',
      postcard_normal: '通常官製ハガキ',
      consumption_tax: 'うち消費税',
      yen: '円',
      year: '年',
      month: '月',
      day: '日',
      sheet: '枚',
      more: '～',
      stamp: 'スタンプ',
      address_print: '宛名印刷',
      unit_stamp: '個',
      item: '件',
      discount_30: ' 30% OFF',
      discount_20: ' 20% OFF',
      discount_10: ' 10% OFF',
      type_discount_30: '早期30',
      type_discount_20: '早期20',
      type_discount_10: '早期10',
      fee_after_discount: '割引適用計',
      postcard_disney: 'ディズニー年賀ハガキ',
      postcard_mourning: '喪中ハガキ',
      all_item: '商品合計',
      print_type: {
        print: '印刷タイプ',
        image: '写真タイプ',
      },
      coupon: 'クーポン',
    },
    comfirm_edit_message: 'ご注文者様情報を修正しますか',
    pay_after_received: '代引き決済に進む',
    message_confirm_payment_cod: '代引き決済画面に遷移してもよろしいですか？',
  },
  a095: {
    title: '再注文・注文イメージ確認',
    re_order_message:
      '再注文または注文イメージを確認する場合は下記を入力してください。',
    order_code: 'オーダー番号',
    name: 'お名前',
    furigana: 'フリガナ',
    email: 'メール',
    phone_number: '電話番号',
    first_name_holder: '姓',
    last_name_holder: '名',
    first_name_kana_holder: 'セイ',
    last_name_kana_holder: 'メイ',
    continue: '続ける',
    validate: {
      order_number_required: 'オーダー番号を入力してください',
      order_number_format: 'オーダー番号は半角数字で入力してください',
      name_required: 'お名前を入力してください',
      name_format: 'お名前は全角で入力してください',
      first_name_required: 'お名前_姓を入力してください',
      last_name_required: 'お名前_名を入力してください',
      first_name_format: 'お名前_姓は全角で入力してください',
      last_name_format: 'お名前_名は全角で入力してください',
      name_kana_required: 'フリガナを入力してください',
      name_kana_format: 'フリガナは全角カナで入力してください',
      first_name_kana_required: 'フリガナ_セイを入力してください',
      first_name_kana_format: 'フリガナ_セイは全角カナで入力してください',
      last_name_kana_required: 'フリガナ_メイを入力してください',
      last_name_kana_format: 'フリガナ_メイは全角カナで入力してください',
      email_required: 'メールを入力してください',
      email_format: 'メールアドレスを正しく入力してください',
      phone_number_required: '電話番号を入力してください',
      phone_number_limit: '電話番号を正しく入力してください',
      phone_number_format: 'TELは半角数字で入力してください',
    },
    order_exits: '注文データが存在しません',
  },
  a090: {
    alert: {
      confirm_to_delete:
        '作成されたハガキの内容がすべて破棄されますがよろしいですか？',
    },
    title: '注文エラー',
  },
  a110: {
    header_title: '注文イメージ',
    screen_title: 'デザイン詳細確認',
    label: {
      order_no: 'オーダー番号',
      image_design: 'デザインイメージ',
      image_header: 'この部分は印刷されません',
      image_footer: 'ここより内側に文字等を配置してください',
    },
    reorder_btn: '再注文する',
  },
  a105: {
    title: '注文イメージ確認',
    errors: {
      invalid_email: 'メールアドレスを正しく入力してください',
      invalid_phone: '電話番号を正しく入力してください',
      invalid_phone_length: '電話番号の長さに誤りがあります',
      invalid_phone_type: '電話番号は半角数字で入力してください',
    },
    re_order_message: '注文イメージ確認を確認する場合は下記を入力してください',
    alert: {
      not_found: '注文データが存在しません',
    },
    validate: {
      required: 'を入力してください',
      length: 'の長さに誤りがあります',
      format_kana: 'は全角カナで入力してください',
      format_number: 'は半角数字で入力してください',
    },
  },
  a100: {
    errors: {
      type_halfsize: '店舗ID_値は半角数字で入力してください',
    },
  },
  a115: {
    header_title: 'ご注文内容の確認（代引き)',
    label: {
      fee_cod: '代引き手数料',
      note_after_cta:
        '内容に問題がなければ下記のボタンを押して注文を確定してください',
      payment_amount: '請求金額',
    },
    modal: {
      confirm: {
        text: '代引き決済による注文を確定してもよろしいですか？',
      },
    },
  },
  a120: {
    header_title: '注文完了',
    message_first_shop:
      'ご注文ありがとうございました。\r\nご登録頂いたメールアドレスに注文完了のメールを送信いたしました。',
    message_middle_shop:
      '同じ内容で再注文する場合は送信完了のメール本文内に記載の再注文用 URL にアクセスしてください。',
    message_bottom_shop:
      'またはサービストップ画面の「再注文はこちらから」をご利用ください。\r\n（注文番号、ご登録頂いた注文者様のお名前、メール、電話番号が必要です）',
  },
  a125: {
    header_title: 'ご注文内容の変更・選択',
    select_payment_method_title: '決済方法を選択',
    select_payment_method_list: {
      credit: 'クレジット',
      cod: '代引き',
    },
    delivery_method_title: '配送方法',
    delivery_method: 'クロネコ宅急便もしくはネコポス',
    validate: {
      select_payment_method_required: '決済方法を選択してください',
    },
    message_select_payment_method: '決済方法を選択してください。',
    message_confirm:
    '内容に問題がなければ［次へ］ボタンを押してください。',
    continue_order: '次へ',
  },
  a130: {
    header_title: 'ご注文内容の確認',
    payment_method_title: '決済方法',
    message_confirm:
      '内容に問題がなければ［注文確定］ボタンを押してください。',
    confirm_paymet: '注文確定',
  },
}
export default lang
